
export enum PillType {
  LessonsLearned = 'LessonsLearned',
  Literature = 'Literature',
  InstitutionalDocuments = 'InstitutionalDocuments',
  SimilarProjects = 'SimilarProjects',
  Data = 'Data',
}
